import { Axios } from 'utils'
import { ICreatSilo, ISilo } from 'types'
import { ItemResponseType, ListResponseType } from './types'

export const useSilosService = () => {
  const getSilos = async () => {
    try {
      const response = await Axios.get<ListResponseType<ICreatSilo>>('/silos')
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const createSilo = async (params: ISilo) => {
    try {
      const response = await Axios.post<ItemResponseType<ISilo>>(
        '/silos',
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateSilo = async (params: ISilo) => {
    try {
      const response = await Axios.put<ItemResponseType<ISilo>>(
        `/silos/${params.id}`,
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getSiloById = async (id: string) => {
    try {
      const response = await Axios.get<ISilo>(`/silos/${id}`)
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const deleteSilo = async (id: number) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/silos/${id}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getSilos,
    createSilo,
    updateSilo,
    getSiloById,
    deleteSilo,
  }
}
